import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { loadDOMComponent } from '../../../../../helpers';
import { AppContextProvider } from '../../../../../Services/AppContext';
import { store } from '../../../../../store/store';
import PasswordPHP from './PasswordPHP';
import { parseBoolean } from '../../../../../Utils/form.util';

loadDOMComponent({
	selector: 'react-password-field',
	callback: ({ container, context, props }: any) => {
		const name = container.getAttribute('name');
		const placeholder = container.getAttribute('placeholder');
		const netteRules = container.getAttribute('data-nette-rules');
		let required = container.getAttribute('required');
		required = required !== false && required !== null;
		const checklist = JSON.parse(container.getAttribute('checklist') || {});
		const loadChecklist = parseBoolean(container.getAttribute('loadChecklist'));

		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider {...context}>
					<PasswordPHP
						name={name}
						placeholder={placeholder}
						netteRules={netteRules}
						isRequired={required}
						checklist={checklist}
						loadChecklist={loadChecklist}
					/>
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
